/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取订单列表统计数据
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.OrderCountInfoRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/orders-count-info`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
